/**
 * API Configuration - ENV ONLY control
 * Set REACT_APP_API_URL in client/.env - change ONLY this when switching local vs VPS
 * Local:  REACT_APP_API_URL=http://localhost:5002
 * VPS:    REACT_APP_API_URL=https://ubsaapp.testatozas.in
 * Restart client (npm start) after changing .env
 */
const getBaseUrl = () => {
  const envUrl = (process.env.REACT_APP_API_URL || '').trim().replace(/\/$/, '');

  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    const isLocalHost =
      host === 'localhost' ||
      host === '127.0.0.1' ||
      host === '0.0.0.0';

    // In local dev, always use local API and ignore stale/non-local env values.
    if (isLocalHost) {
      if (envUrl && !/^https?:\/\/(localhost|127\.0\.0\.1|0\.0\.0\.0)(:\d+)?$/i.test(envUrl)) {
        console.warn('Ignoring non-local REACT_APP_API_URL on localhost:', envUrl);
      }
      return 'http://localhost:5002';
    }

    // Non-local host: use env value when set, otherwise same origin.
    const fallback = window.location.origin.replace(/\/$/, '');
    return envUrl || fallback;
  }

  return envUrl || 'http://localhost:5002';
};

export const API_BASE_URL = getBaseUrl();

export const getApiUrl = (endpoint) => {
  const path = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  // Always use full URL so we don't rely on proxy (avoids "Proxy error: ECONNREFUSED" when backend is starting)
  return `${API_BASE_URL}${path}`;
};

/** Use for full-page redirects (e.g. OAuth). Always returns full server URL so the browser hits the API server, not the React dev server. */
export const getApiUrlAbsolute = (endpoint) => {
  const path = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${API_BASE_URL}${path}`;
};

// Export for direct use
export default {
  baseURL: API_BASE_URL,
  getUrl: getApiUrl,

  // Common endpoints
  auth: {
    checkUser: () => getApiUrl('/api/auth/check-user'),
    sendOtp: () => getApiUrl('/api/auth/send-otp'),
    verifyOtp: () => getApiUrl('/api/auth/verify-otp'),
    resendOtp: () => getApiUrl('/api/auth/resend-otp'),
    googleAuth: () => getApiUrl('/api/auth/google'),
    me: () => getApiUrl('/api/auth/me'),
    aadhaarConfig: () => getApiUrl('/api/auth/aadhaar/config'),
    aadhaarSendOtp: () => getApiUrl('/api/auth/aadhaar/send-otp'),
    aadhaarVerifyOtp: () => getApiUrl('/api/auth/aadhaar/verify-otp'),
    registerCompany: () => getApiUrl('/api/auth/register-company'),
    companyLogin: () => getApiUrl('/api/auth/company-login'),
  },

  properties: {
    all: () => getApiUrl('/api/properties/all'),
    featured: () => getApiUrl('/api/properties/featured'),
    offers: () => getApiUrl('/api/properties/offers-with-discounts'),
  },

  bookings: {
    create: () => getApiUrl('/api/bookings'),
    list: () => getApiUrl('/api/bookings'),
  },

  notifications: {
    email: () => getApiUrl('/api/notifications/email'),
    push: () => getApiUrl('/api/notifications/push'),
    inApp: () => getApiUrl('/api/notifications/in-app'),
  },
};

// Debug helper
if (process.env.NODE_ENV === 'development') {
  console.log('API Configuration:', {
    baseURL: API_BASE_URL,
    nodeEnv: process.env.NODE_ENV,
  });
}
